import type {Ref} from 'vue';
import {ref} from 'vue';
import {defineNuxtPlugin} from '#imports';

export default defineNuxtPlugin({
    name: 'locale-to-sync-with-server',
    dependsOn: [],
    setup(): {
        provide: {
            localeToSyncWithServer: Ref<string | null>;
        };
    } {
        return {
            provide: {
                localeToSyncWithServer: ref(null),
            },
        };
    },
});
